import { useDispatch, useSelector } from 'react-redux';
import { Table } from '@quintoandar-tokko/jopijs';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import parentStyles from '../dashboardTables.module.scss';
import specificStyles from './conversionRateTable.module.scss';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';
import HeaderCell from '../components/HeaderCell';
import { TABLE_SORT_FIELDS } from '../../constants';
import ConversionRateGroupedTableContent from './ConversionRateGroupedTableContent';
import ConversionRateNonGroupedTableContent from './ConversionRateNonGroupedTableContent';
import useTrackPerformanceTable from '@/components/Dashboard/customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

export default function ConversionRateTable() {
  const dispatch = useDispatch();

  const { conversionRate } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );
  const track = useTrackPerformanceTable();

  const headers = [
    {
      id: 1,
      title: Trans(translations, 'Agent'),
      subtitle: Trans(translations, 'Branch'),
      field: TABLE_SORT_FIELDS.AGENT_NAME,
    },
    {
      id: 2,
      title: Trans(translations, 'ConversionRate'),
      field: TABLE_SORT_FIELDS.CONVERSION_RATE,
    },
    {
      id: 3,
      title: Trans(translations, 'AssignedContacts'),
      field: TABLE_SORT_FIELDS.ASSIGNED_CONTACTS,
    },

    {
      id: 4,
      title: Trans(translations, 'DashboardTableColumn.WithVisits'),
      field: TABLE_SORT_FIELDS.WITH_VISITS,
    },
    {
      id: 5,
      title: Trans(translations, 'DashboardTableColumn.WithReservations'),
      field: TABLE_SORT_FIELDS.WITH_RESERVATIONS,
    },
    {
      id: 6,
      title: Trans(translations, 'NewContactsTableSearchStatus.Concreted'),
      field: TABLE_SORT_FIELDS.CONCRETED,
    },
    {
      id: 7,
      title: Trans(translations, 'NewContactsTableSearchStatus.Lost'),
      field: TABLE_SORT_FIELDS.LOST,
    },
    {
      id: 8,
      title: Trans(translations, 'InProgress'),
      field: TABLE_SORT_FIELDS.IN_PROGRESS,
    },
  ];

  const handleCellClick = (header) => {
    dispatch(
      setPerformanceModals({
        key: 'conversionRate',
        subkey: 'sortBy',
        value: header.field,
      })
    );
    track.conversionRate(TRACK_ELEMENT.COLUMN_ORDER);
  };

  return (
    <Table
      id="conversion-rate-table"
      className={`${parentStyles.table} ${specificStyles.conversionRateTable}`}
    >
      <Table.Header className={parentStyles.tableHeader}>
        {headers.map((header) => (
          <HeaderCell
            key={header.id}
            id={header.id}
            title={header.title}
            subtitle={header.subtitle}
            field={header.field}
            sortBy={conversionRate.sortBy}
            sortDirection={conversionRate.sortDirection}
            onClick={() => handleCellClick(header)}
          />
        ))}
      </Table.Header>

      {conversionRate.groupByBranch ? (
        <ConversionRateGroupedTableContent headers={headers} />
      ) : (
        <ConversionRateNonGroupedTableContent headers={headers} />
      )}
    </Table>
  );
}
